import { browserHistory } from '../services/history'
import { AnalyticsService } from '../services/analytics'
import { firstBookingStepPath } from './booking-flow'
import { readWashes } from './page-prices'
import { defaultWash } from './wash-order'

// THE WASH A BOOK BUTTON NAMES WHEN IT HAS NONE OF ITS OWN (Fable, amended
// 31 Oct 2026). A no-slug link opens Book & pay with the wash PICKER OPEN,
// so the first thing a visitor who just pressed Book is asked to do is
// choose; naming the wash a booking starts on anyway
// (CustomerCatalogue::DEFAULT_WASH) shuts the picker and starts the booking
// decided. Every on-site Book button goes through this when it does not
// belong to a wash of its own.
//
// NO CONVERSION CLAIM. Re-run inside one era, each person grouped by their
// first `booking_entry`, preselected and not-preselected convert the same
// within noise and in both directions by window (6.9% of 102 against 8.9%
// of 79 since 5 Oct; 7.7% of 39 against 5.1% of 59 since 20 Oct). This is a
// consistency rule, not an evidence-based one.
//
// `general` (no slug at all) survives in exactly three kinds of place, none
// of them a page a stranger is browsing: the HEADER bar and the account menu
// (they belong to no wash and sit on every page), the COACH's links, and the
// REMINDER and winback MAILERS. Server twin: BookingLinks.default_wash.
//
// Null when the server has not sent a catalogue: the link is then the
// general one, which still opens on the same wash, just with the picker
// open. Nothing here guesses a slug.
export const defaultWashSlug = () => defaultWash(readWashes())?.slug || null

// One place that knows how a visitor gets from the marketing page into the
// booking screen, so the home-page sections do not each invent their own
// route and their own event name.
//
// Keep the href AND the click handler on every wash tile: the href is what a
// crawler, a middle click and a long press follow, the handler is what the
// SPA uses so the navigation does not reload the bundle.
//
//   <Card href={bookingPath(slug)} onClick={e => { e.preventDefault(); enterBooking(slug, 'hero_wash_card') }}>

// Where a wash tile points when followed as a plain link. `extra` is an
// add-on's catalogue key (CustomerCatalogue, e.g. 'engine_bay_cleaned'): the
// book step ticks it on arrival. Used by the before/after "Book this" links.
export const bookingPath = (slug, { extra } = {}) => {
  const params = [slug && `service=${slug}`, extra && `extra=${extra}`].filter(Boolean)
  return firstBookingStepPath(params.length > 0 ? `?${params.join('&')}` : '')
}

// `source` names the thing that was tapped and lands on the PostHog
// `booking_entry` event as `entry_source`. It is how we will know whether the
// fold cards earn their place, so make it specific: 'hero_wash_card',
// 'included_section_button', 'final_cta'.
// Q-85: AN ENTRY NOBODY CLICKED. An ad, a WhatsApp rebook link, the Business
// Profile's booking link or a bookmark loads /booking/... as the first
// document, with no in-app tap to fire booking_entry, so those visitors were
// invisible at the top of the funnel. The URL the browser loaded is taken once,
// as the bundle first runs; BookingPage calls this on mount, and it fires
// `booking_entry` with entry_source 'direct_url' only when that first document
// was a booking entry step. Once per page load: a visitor who came in on the
// home page and tapped through has already fired their own entry (above), and
// the landing URL was not /booking, so nothing fires twice.
const LANDING = typeof window === 'undefined' ? null : { path: window.location.pathname, search: window.location.search }
const COLD_ENTRY = /^\/booking(?:\/(book|details|service|address))?\/?$/
let landingChecked = false

export const trackDirectBookingEntry = () => {
  if (landingChecked || !LANDING) return
  landingChecked = true
  if (!COLD_ENTRY.test(LANDING.path)) return

  const query = new URLSearchParams(LANDING.search)
  const slug = query.get('service')
  const extra = query.get('extra')
  AnalyticsService.trackBookingEntry('direct_url', {
    ...(slug ? { service_slug: slug } : {}),
    ...(extra ? { extra_key: extra } : {})
  })
}

export const enterBooking = (slug, source, { extra } = {}) => {
  AnalyticsService.trackBookingEntry(source, {
    ...(slug ? { service_slug: slug } : {}),
    ...(extra ? { extra_key: extra } : {})
  })
  browserHistory.push(bookingPath(slug, { extra }))
}
